(function componentForm($, Adzuki)
{
	"use strict";

	var form = {
		name                 : 'AddToCpInsights',
		confirm_before_submit: true,
		confirm_message      : "There is a charge associated with recoding these clients. Do you wish to continue?"
	};

	$(document).ready(function documentReady()
	{
		Adzuki.Form.registerForm(form);
	});
}(jQuery, window.Adzuki || {}));